import { Dispatch, SetStateAction, useEffect } from "react";
import GoogleLogin from "../components/login/portal/GoogleLogin";
import { Helmet } from "react-helmet-async";

/**
 * @interface
 * @prop {Dispatch<SetStateAction<boolean>>} setIsLogin
 */
interface GoogleLoginScreenProps {
    setIsLogin: Dispatch<SetStateAction<boolean>>;
}

function GoogleLoginScreen(props: GoogleLoginScreenProps) {
    useEffect(() => {
        const iamport = document.createElement("script");
        const jquery = document.createElement("script");
        iamport.src = "https://cdn.iamport.kr/js/iamport.payment-1.1.7.js";
        jquery.src = "https://code.jquery.com/jquery-1.12.4.min.js";
        document.head.appendChild(iamport);
        document.head.appendChild(jquery);
        props.setIsLogin(true);
        return () => {
            props.setIsLogin(false);
            document.head.removeChild(iamport);
            document.head.removeChild(jquery);
        };
    }, []);

    return (
        <>
            <Helmet>
                <title>구글간편로그인 - 모두의지도</title>
                <meta name="description" content="구글로 간편 로그인" />
            </Helmet>
            <div>
                <GoogleLogin />
            </div>
        </>
    );
}

export default GoogleLoginScreen;
